import Axios from "axios";

export default {
    getItemDiscounts(itemId) {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/${itemId}/discounts`
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    async updateItemDiscount(itemId, discountId, isApplicable) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}inventory/exclude-discount`,
            {
                item_id: itemId,
                discount_id: discountId,
                is_applicable: isApplicable
            }
        );

        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    }
};
